import React from 'react';
import '../styles/ChairRegistrationModal.css';
import { Occupant } from '../types';

interface OccupiedSeatModalProps {
  isOpen: boolean;
  onClose: () => void;
  onVacate: () => void;
  chairNumber: number | null;
  occupant: Occupant | null;
}

const formatDuration = (since?: string): string => {
  if (!since) return '—';
  const start = new Date(since).getTime();
  const now = Date.now();
  const diffMs = Math.max(0, now - start);
  const mins = Math.floor(diffMs / 60000);
  const hours = Math.floor(mins / 60);
  const days = Math.floor(hours / 24);
  if (days > 0) return `${days}d ${hours % 24}h`;
  if (hours > 0) return `${hours}h ${mins % 60}m`;
  return `${mins}m`;
};

const formatHoursOnly = (since?: string): string => {
  if (!since) return '—';
  const start = new Date(since).getTime();
  const now = Date.now();
  const diffMs = Math.max(0, now - start);
  const hoursFloat = diffMs / 3600000; // ms to hours
  return `${hoursFloat.toFixed(1)} hours`;
};

const formatSince = (since?: string): string => {
  if (!since) return '—';
  const d = new Date(since);
  return d.toLocaleString();
};

const OccupiedSeatModal: React.FC<OccupiedSeatModalProps> = ({ isOpen, onClose, onVacate, chairNumber, occupant }) => {
  if (!isOpen || !occupant) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Seat A-{chairNumber} Details</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <div className="profile-row">
            <div className="profile-avatar">{occupant.name.charAt(0).toUpperCase()}</div>
            <div className="profile-meta">
              <div className="profile-name">{occupant.name}</div>
              <div className="profile-sub">{occupant.role} • Occupied {formatDuration(occupant.occupiedSince)}</div>
            </div>
          </div>
          <div className="detail-grid">
            <div className="detail-item"><span className="label">Type</span><span className="value">{occupant.studentType === 'registered' ? 'Registered' : 'Test'}</span></div>
            <div className="detail-item"><span className="label">Email</span><span className="value">{occupant.email}</span></div>
            <div className="detail-item"><span className="label">Mobile</span><span className="value">{occupant.mobileNumber || '—'}</span></div>
            <div className="detail-item"><span className="label">RFID</span><span className="value">{occupant.rfid || '—'}</span></div>
            {occupant.department && (
              <div className="detail-item"><span className="label">Department</span><span className="value">{occupant.department}</span></div>
            )}
            <div className="detail-item"><span className="label">Occupied For</span><span className="value">{formatDuration(occupant.occupiedSince)} ({formatHoursOnly(occupant.occupiedSince)})</span></div>
            <div className="detail-item"><span className="label">Since</span><span className="value">{formatSince(occupant.occupiedSince)}</span></div>
          </div>
        </div>
        <div className="modal-actions">
          <button className="btn btn-cancel" onClick={onClose}>Close</button>
          <button className="btn btn-danger" onClick={onVacate}>Make Vacant</button>
        </div>
      </div>
    </div>
  );
};

export default OccupiedSeatModal;


